import { GET_SITE_PROPERTIES } from '../../constants/ActionTypes';

/**
 * Get site propreties.
 * @function getSiteProperties
 * @returns {Object} Get the site propreties
 */
export function getSiteProperties() {
  return {
    type: GET_SITE_PROPERTIES,
    request: {
      op: 'get',
      path: '/@govsite',
    },
  };
}
